export const SOFTLINE_API_CERTIFICATE_SUPPLIER = '/coc-service/certificate/supplier/{{supplierId}}';
export const SOFTLINE_API_CERTIFICATE_DOCUMENT = '/coc-service/certificate/document';
export const SOFTLINE_API_CERTIFICATE_DOCUMENT_QUERY =
  '/coc-service/certificate/document/{{documentType}}/{{documentId}}';
